module.exports = { apiBaseUrl: 'https://api.besidethepark.com' };
